/**
 * © 2026 iTech India Private Limited. All rights reserved.
 * Licensed under the iTech End User License Agreement (EULA).
 * Unauthorized use or distribution is prohibited.
 */

import { type JSX } from 'react';
import { useTranslation } from 'react-i18next';

import { cn } from '../../lib/utils/cn.js';

/** Wizard progress: a segmented bar + "Step X of N" for the parent intake form. */
export function IntakeStepNav({
  steps,
  current,
}: {
  readonly steps: readonly string[];
  readonly current: number;
}): JSX.Element {
  const { t } = useTranslation();
  return (
    <div>
      <div className="mb-2 flex items-center justify-between text-sm">
        <span className="font-medium text-slate-500 dark:text-slate-400">
          {t('intake.stepOf', { current: current + 1, total: steps.length })}
        </span>
      </div>
      <div className="flex gap-1.5" aria-hidden="true">
        {steps.map((step, i) => (
          <div
            key={step}
            className={cn(
              'h-1.5 flex-1 rounded-full',
              i <= current ? 'bg-[var(--accent)]' : 'bg-slate-200 dark:bg-slate-700',
            )}
          />
        ))}
      </div>
    </div>
  );
}
